import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import { StyledModal, StyledSurface } from './styles';
import { type ModalProps } from './types';

/**
 * A full-viewport modal surface.
 *
 * It owns only what every modal needs and nothing about presentation: the
 * portal, the scrim, Escape-to-close, the focus trap, returning focus to
 * whatever opened it, and locking the page behind it. The children lay
 * themselves out — use this for full-bleed overlays such as a media viewer,
 * and `PopUp` for the standard centred dialog card.
 *
 * Click-to-dismiss is deliberately not built in. It might look like Modal
 * could treat "outside children" as dismissible on its own, but children can
 * be a full-bleed layout with no gap around them at all — in Lightbox, the
 * dismissible whitespace is the padding inside its own `StyledImageArea`,
 * nested *inside* children rather than outside them. A click bubbling up
 * from inside children is indistinguishable from one that never touched
 * them; only the caller's layout knows which parts of what it rendered are
 * "background" and which are foreground.
 */
const Modal = t0 => {
  const $ = _c(13);
  const {
    open,
    onClose,
    children,
    ariaLabel,
    ariaLabelledBy,
    blurBackdrop: t1,
    onClick,
    className,
    dataTestId,
    ref
  } = t0;
  const blurBackdrop = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== ariaLabel || $[1] !== ariaLabelledBy || $[2] !== children || $[3] !== className || $[4] !== dataTestId || $[5] !== onClick || $[6] !== ref) {
    t2 = <StyledSurface ref={ref} role="dialog" aria-modal={true} aria-label={ariaLabel} aria-labelledby={ariaLabelledBy} onClick={onClick} className={className} data-testid={dataTestId} tabIndex={-1}>{children}</StyledSurface>;
    $[0] = ariaLabel;
    $[1] = ariaLabelledBy;
    $[2] = children;
    $[3] = className;
    $[4] = dataTestId;
    $[5] = onClick;
    $[6] = ref;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== blurBackdrop || $[9] !== onClose || $[10] !== open || $[11] !== t2) {
    t3 = <StyledModal open={open} onClose={onClose} blurBackdrop={blurBackdrop}>{t2}</StyledModal>;
    $[8] = blurBackdrop;
    $[9] = onClose;
    $[10] = open;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default Modal;